<one-select
  #select
  [config]="config"
  [keys]="KEYS"
  [dataSource]="source"
  [label]="label"
  [multiple]="multiple"
  [disabled]="isDisabled"
  (selectionChanged)="onSelectionChanged($event)"
></one-select>
